<script>
export default
{
    name: 'svg-background',

    props:
    {
        src: { type: String, required: true }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='svg-background'>
                <inline-svg src={this.src} class='background' />
                <div class='content'>{this.$slots.default}</div>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
.svg-background
{
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .background
    {
        position: absolute;
        width: inherit;
        height: inherit;
        fill: var(--theme-accent-color-light);
    }

    .content
    {
        z-index: 1;
        width: -webkit-fill-available;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/SvgBackground.vue